import { type Transaction } from '@atlaskit/editor-prosemirror/state';

import { ACTIONS } from './actions';
import { aiAnnotationWatchmenPluginKey } from './ai-annotation-watchmen-plugin-key';

export const startWatchingAnnotationChanges =
	({ from, to }: { from: number; to: number }) =>
	(tr: Transaction): Transaction => {
		return tr.setMeta(aiAnnotationWatchmenPluginKey, {
			action: ACTIONS.START_WATCHING_REGION,
			from,
			to,
		});
	};

export const endWatchingAnnotationChanges = (tr: Transaction): Transaction => {
	return tr.setMeta(aiAnnotationWatchmenPluginKey, { action: ACTIONS.END_WATCHING_REGION });
};
